import $ from '../vendor/jquery';

//Restyle freeform submit button
$('.freeform-row button').addClass('btn primary-btn');

$('.play-button').magnificPopup({ type: 'iframe' });



// WEBPACK FOOTER //
// ./public/assets/js/src/components/buttons.js